import { render } from "./HelloWorld.vue?vue&type=template&id=9dea0428&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=9dea0428&scoped=true&lang=css"

import exportComponent from "C:\\Fejlesztések\\JelentkezesiRendszer\\FrontEnd\\Eredeti\\jelentkezesirendszer_frontend_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dea0428"]])

export default __exports__